import axios from 'axios'

import { COP_COMMON_ERROR_MESSAGES } from '../constants/common-error-messages'
import { CASES_ENDPOINT,COP_API_BASE_URL } from '../constants/service-endpoints'
import { ToastService } from './toast.service'
import { buildCopHeaders, getSilentToken} from './tokenUtils'

export interface CaseListParams {
  top?: number
  skip?: number
  orderby?: string
  count?: boolean
  filter?: string
  kind?: string
  relatedFilter?: string
}

export interface Case {
  id: string
  number: string
  status: string
  product: string
  subject: string
  customerReference: string
  dateTimeOpened: string
  severity: string
}

export interface CaseListResponse {
  '@odata.count'?: number
  value: Case[]
}

function buildFilterExpression(search: string): string {
  const escaped = search.replace(/'/g, "''")
  return `((((contains(Number,'${escaped}')) or (contains(Status,'${escaped}')) or (contains(Severity,'${escaped}')) or (contains(Product,'${escaped}')))))`
}

function buildODataQuery(params: Omit<CaseListParams, 'kind'>): string {
  const query = new URLSearchParams()
  query.set('$count', String(params.count ?? true))
  if (params.top !== undefined && params.skip !== undefined) {
    query.set('$orderby', params.orderby ?? 'dateTimeOpened desc')
    query.set('$top', String(params.top))
    query.set('$skip', String(params.skip))
  }
  const filterParts: string[] = []
  if (params.relatedFilter) {
    filterParts.push(params.relatedFilter)
  }
  if (params.filter) {
    filterParts.push(buildFilterExpression(params.filter))
  }
  if (filterParts.length > 0) {
    query.set('$filter', filterParts.join(' and '))
  }
  return `?${query.toString()}`
}

export async function fetchCases(
  params: CaseListParams = {},
): Promise<CaseListResponse | null> {
  const {
    top,
    skip,
    orderby,
    count = true,
    filter = '',
    kind = 'MyOpenCases',
    relatedFilter = '',
  } = params

  try {
    const token = getSilentToken();
    const url = `${COP_API_BASE_URL}${CASES_ENDPOINT}/GetCaseBasics(kind='${kind}')${buildODataQuery({ top, skip, orderby, count, filter, relatedFilter })}`
    const headers = buildCopHeaders(token)
    const response = await axios.get<CaseListResponse>(url, { headers })
    const { '@odata.count': odataCount, value } = response.data
    return { '@odata.count': odataCount, value }
  } catch (error) {
    const fallbackMessage = COP_COMMON_ERROR_MESSAGES['api-error'].message.replace(
      '{{action}}',
      COP_COMMON_ERROR_MESSAGES['api-error'].action['cases-loading'],
    )
    const message = error instanceof Error && error.message ? error.message : fallbackMessage
    ToastService.error(message)
    return null
  }
}

